import { z } from "zod";

export const fieldVisitCreationSchema = z.object({
  account: z.any().optional(),
  usuarioMobile: z.any().optional(),
  procedencia: z.any().optional(),
  fechaDeseada: z.any().optional(),
  contacto: z.any().optional(),
  motivo: z.any().optional(),
  motivoLabel: z.any().optional(),
  motivoOtroDetalle: z.any().optional(),
  observacionProductor: z.any().optional(),
});
